import { render, staticRenderFns } from "./TaskFormPage.vue?vue&type=template&id=6d7281d1"
import script from "./TaskFormPage.vue?vue&type=script&lang=js"
export * from "./TaskFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports